"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reply = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const lucide_react_1 = require("lucide-react");
const useStore_1 = require("../../store/useStore");
require("./Reply.css");
const Reply = () => {
    const { activeReply, getMessageById, getUserById, clearActiveReply } = (0, useStore_1.useStore)();
    if (!activeReply)
        return null;
    const message = getMessageById(activeReply);
    if (!message)
        return null;
    // DM messages use sender_id/sender_name; channel messages use authorId/authorName
    const authorId = message.authorId || message.sender_id;
    const authorName = message.authorName || message.sender_name;
    const author = authorId ? getUserById(authorId) : undefined;
    const displayName = author?.displayName || author?.username || authorName || 'Kullanıcı';
    // --- Webhook parsing ---
    let isWebhook = false;
    let finalName = displayName;
    let finalContent = message.content || '';
    if (message.content && message.content.startsWith('WEBHOOK:')) {
        isWebhook = true;
        try {
            const jsonStr = message.content.replace('WEBHOOK:', '');
            const wdata = JSON.parse(jsonStr);
            finalName = wdata.name || finalName;
            finalContent = wdata.content || '';
        }
        catch { }
    }
    const previewContent = message.attachments && message.attachments.length > 0
        ? '📎 Görsel eki'
        : finalContent;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "reply-bar", children: [(0, jsx_runtime_1.jsx)("div", { className: "reply-bar-left", children: (0, jsx_runtime_1.jsxs)("span", { className: "reply-bar-title", children: [(0, jsx_runtime_1.jsx)("span", { style: { fontWeight: 600, color: 'var(--text-normal)' }, children: finalName }), " ki\u015Fisine yan\u0131t veriliyor"] }) }), (0, jsx_runtime_1.jsx)("button", { className: "reply-bar-close", onClick: clearActiveReply, title: "Yan\u0131tlamay\u0131 iptal et", children: (0, jsx_runtime_1.jsx)(lucide_react_1.X, { size: 16 }) })] }));
};
exports.Reply = Reply;
